import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environments';

@Injectable()
export class RoomService {
  roomsRef: AngularFireList<any>;
  rooms: Observable<any[]>;

  openLogs = true;
  logs;
  lockBoard;
  room;
  roomRef: AngularFireList<any>;
  roomId: string;
  createdRoomUrl;

  constructor(public afd: AngularFireDatabase) {
    this.roomsRef = afd.list('rooms');
    this.rooms = this.roomsRef.snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    });
  }

  actionSaveLocalStorage(cards) { // WARNING no cards in inputs before fix
    const saveData = JSON.stringify({ cards: cards });
    localStorage.setItem('save', saveData);
  }

  actionLoadLocalStorage() {
    const retrievedData = JSON.parse(localStorage.getItem('save'));
    const data = retrievedData.cards;
    return data;
  }

  /* addRoom(users, roomCreationId, cards, counters) {
    this.logs = [];
    this.logs.push({
      label: 'Starting game',
      prefix: null,
      template: 'Default'
    });
    return this.roomsRef.push({
      cards: cards,
      counters: counters,
      hub: {
        hubId: roomCreationId
      },
      game: {
        activePlayer: users[0].uid
      },
      logs: this.logs
    });// .then(createdRoomUrl => this.createdRoomUrl = createdRoomUrl);
  } */

  addRoom(users, roomCreationId, cards, counters) {
    this.logs = [];
    this.logs.push({
      label: 'Starting game',
      prefix: null,
      template: 'Default'
    });
    let defaultData = {
      cards: cards,
      counters: counters,
      hub: {
        hubId: roomCreationId
      },
      game: {
        activePlayer: users[0].uid
      },
      logs: this.logs
    };
    this.roomsRef.set(users[0].uid, defaultData);
    return defaultData;
    // return this.afd.object(`/hub/${user.uid}`).set(defaultData);
  }

  updateRoom(room, data, log?) {
    this.lockBoard = true;
    this.roomsRef.set(room, data).then(res => {
      this.lockBoard = false;
      if (log) {
        this.updateRoomLogs(this.roomId, log);
      }
    });
  }

  updateRoomLogs(roomId, log) {
    const maxLogSize = 150;
    this.logs.push(log);
    this.logs = this.logs.slice(Math.max(this.logs.length - maxLogSize, 1));
    // WARNING FIREBASE DEPLOY FAILED
    // this.roomsRef.set(`${this.roomId}/logs`, this.logs);
  }

  deleteAllRooms() {
    this.roomsRef.remove();
  }

  deleteRoom(roomId: string) {
    this.roomsRef.remove(roomId);
  }
}
